import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { Assignment, AssignmentOutlined } from "@material-ui/icons";
export const OutcomeDocsToggle = props => {
    return (React.createElement(Tooltip, { title: props.title },
        React.createElement(IconButton, { className: "ActivityStar", onClick: () => props.onClick(), disabled: props.disabled, "data-test": props.hook },
            " ",
            props.isSelected ? (React.createElement(Assignment, { fontSize: "default" })) : (React.createElement(AssignmentOutlined, { fontSize: "default" })))));
};
